import _ from 'lodash'
import $ from 'jquery'

import React    from 'react'
import Keyboard from 'react-virtual-keyboard'

import 'jquery-ui/ui/position'
import 'jquery-ui/themes/base/theme.css'

import 'virtual-keyboard/dist/css/keyboard.min.css'

import './keyboard_czech_layout'
import './keyboard.sass'

defaultOptions =
  layout: 'ms-Czech-less-actions'
  noFocus: true
  alwaysOpen: true
  usePreview: false
  display:
    bksp:   '\u232b:Backspace',
    accept: 'Potvrdit:Accept (Shift-Enter)',
    cancel: 'Zrušit:Cancel (Esc)'
    clear:  'Vymazat'
  position:
    of:        $(document)
    my:        'center bottom'
    at:        'center bottom'
    at2:       'center bottom'
    collision: 'flipfit flipfit'

class CustomKeyboard extends Keyboard
  componentWillReceiveProps: ({ value }) ->
    @setState({ value }) unless value == @props.value

  componentWillUnmount: ->
    @keyboard.destroy()
    super()

  resetKeyboard: ->
    @keyboard.destroy()

    @props.options.accepted = (event, keyboard, el) =>
      @handleChange('', el.value)
      @props.onAccepted?(el.value)

    @addKeyBoardToDOM()

  render: ->
    InputTag   = if @props.options.type == 'textarea' then 'textarea' else 'input'
    inputProps = _.omit(@props, 'options', 'value', 'validation', 'debug', 'onChange', 'onAccepted')

    input = <InputTag
             ref={(node) => @keyboardRef = node}
             value={@state.value}
             onChange={@handleChange}
             {...inputProps} />

    <div className={@state.className}>{input}</div>

wrapper = (props, ref) ->
  options       = _.defaults({}, props.options or {}, defaultOptions)
  keyboardProps = _.assign({}, props, { options })

  <CustomKeyboard {...keyboardProps} ref={ref} />

export default React.forwardRef(wrapper)
